import React from 'react';
import classNames from "classnames";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {useCollapse} from "react-collapsed";

export class CollapsibleListProps extends BaseProps {
  duration: Number;
  open: Boolean;
  easing: String;
  transitionTime: Number;
  keepInDOM: Boolean;
}

export const CollapsibleList = (props: CollapsibleListProps) => {
  const {getCollapseProps} = useCollapse({
    isExpanded: props.open,
    duration: props.transitionTime || 250,
    easing: props.easing || 'ease',
  });

  const containerProps = props.keepInDOM
    ? {className: classNames({'collapsible-list-hidden': !props.open})}
    : getCollapseProps();

  return (
    <div {...containerProps}>
      {(props.keepInDOM || props.open) && props.children}
    </div>
  );
}
